/* Street Legal — small behaviours for the custom sections. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Fade/slide things in as they scroll into view */
  const io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.add('is-in');
                io.unobserve(e.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        )
      : null;

  function revealIn(root) {
    root.querySelectorAll('[data-sl-reveal]:not(.is-in)').forEach((el) => {
      if (!io || reduce) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  /* Hero entrance */
  function heroIn(root) {
    root.querySelectorAll('.sl-hero:not(.is-loaded)').forEach((hero) => {
      requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is-loaded')));
    });
  }

  /* Live Dubai clock in the hero meta row */
  function clocks() {
    const els = document.querySelectorAll('[data-sl-clock]');
    if (!els.length) return;
    const fmt = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'Asia/Dubai',
    });
    els.forEach((el) => (el.textContent = fmt.format(new Date())));
  }
  setInterval(clocks, 1000);

  /* Scale big wordmarks so they fill the full width exactly */
  function fit() {
    document.querySelectorAll('[data-sl-fit]').forEach((el) => {
      const inner = el.querySelector('.sl-fit');
      if (!inner) return;
      el.style.fontSize = '100px';
      const w = inner.getBoundingClientRect().width;
      if (w) el.style.fontSize = (100 * el.clientWidth) / w + 'px';
    });
  }
  window.addEventListener('resize', fit);
  if (document.fonts) document.fonts.ready.then(fit);


  /* Video banners: only download + play while on screen; poster only for reduced motion */
  const vio =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              const v = e.target;
              if (e.isIntersecting) {
                if (!v.dataset.loaded) {
                  v.querySelectorAll('source[data-src]').forEach((s) => (s.src = s.dataset.src));
                  v.load();
                  v.dataset.loaded = '1';
                }
                if (v.dataset.playback === 'once' && v.ended) v.currentTime = 0;
                v.play().catch(() => {});
              } else if (!v.ended) {
                v.pause();
              }
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  function videoBanners(root) {
    root.querySelectorAll('[data-sl-vbanner] video').forEach((v) => {
      if (reduce) return; // keep the still poster
      if (vio) vio.observe(v);
      else {
        v.querySelectorAll('source[data-src]').forEach((s) => (s.src = s.dataset.src));
        v.load();
        v.play().catch(() => {});
      }
    });
  }

  function init(root = document) {
    heroIn(root);
    revealIn(root);
    clocks();
    fit();
    videoBanners(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  /* Re-run when a section is edited in the Shopify theme editor */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
